module.exports = __webpack_public_path__ + "3cf31802b283dfe40f4e673c4650a55f.pdf";